<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title">The Eight Strokes of the Clock</p>
<p class="bk-subtitle">An Arsène Lupin Adventure</p>
<p class="authorname">Maurice Leblanc</p>
<p class="publisher"><span><img alt="logo1" class="svg" src="fig_logo.jpg"/></span></p>
<p class="publisher1"><span><a href="http://MYSTERIOUSPRESS.COM" target="_blank">MYSTERIOUSPRESS.COM</a></span></p>
<p class="publisher1"><span><img alt="logo" class="svg" src="logo.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?5dd113f4